export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查地址"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入地址"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择区块链"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["执行检查"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["低风险"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中等风险"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["高风险"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不在黑名单中"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检查其他地址"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下载 PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择提供商"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择 AML 提供商"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检测服务暂时不可用，请稍后再试。"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["检测未执行。"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结果未确认 — 请稍后重试。"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["暂无可用的检测提供商。请联系管理员。"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["该提供商未配置任何网络。请联系管理员。"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["网络未配置"])}
}